/** @jsxImportSource @emotion/react */
import { NavLink, NavLinkProps } from "react-router-dom";
import { StyledText } from "../assets/typography/typography";
import { colors } from "./colors";
import { css } from "@emotion/react";
import { effects } from "./effects";
import React from "react";

export const SecondaryNavigationLink = ({
  children,
  ...rest
}: NavLinkProps) => {
  const navLinkStyle = css`
    display: flex;
    align-items: center;
    padding: 8px 12px;
    margin-bottom: 0px;
    text-decoration: none !important;
    border-radius: 9999px;
    &:hover {
      color: ${colors.textPrimary} !important;
    }
  `;

  return (
    <NavLink
      css={navLinkStyle}
      style={({ isActive }) => {
        if (!isActive) {
          return {
            color: colors.textSecondary,
          };
        }
        return {
          boxShadow: effects.cardRest,
          backgroundColor: colors.white,
          color: colors.textPrimary,
        };
      }}
      {...rest}
    >
      {({ isActive }) => (
        <StyledText
          className={`${
            isActive ? "bodyTextSemibold" : "bodyTextRegular"
          } mb-0`}
        >
          {children as React.ReactNode}
        </StyledText>
      )}
    </NavLink>
  );
};
